import React, { Component, Fragment } from 'react'
import { withStyles } from '@material-ui/core/styles'
import cx from 'classnames'

// COMPONENTS
import Typography from '@material-ui/core/Typography'
import Wrapper from '../components/wrapper'
import LeftNavigationDashboard from '../components/app-navigation/LeftNavigationDashboard'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import LogoData from '../components/app-logo/logo-data'
import Avatar from '@material-ui/core/Avatar'
import { ButtonEdit } from '../components/app-button/button'
import EcomModuleDashboard from '../components/ecom/EcomModuleDashboard'
import CustomizeAll from '../components/сustomize-all/'
import MessageBoard from '../components/messageBoard'
import TraficLight from '../components/traficLight'
import MarketingDashboard from '../components/MarketingDashboard'
import LicenseExpired from '../components/payment/LicenseExpired'
import { ActionsForUsing } from '../components/payment/LicenseExpired'
import BannerDailyReport from '../components/MarketingDashboard/BannerDailyReport'
import AcceptTerm from '../components/accept-term/'

import {
  YandexMarketIcon,
  YandexDirectIcon,
  GoogleAdsIcon,
  VkIcon,
  FbIcon,
  AccountIdentifierIcon,
  AccountWaitIcon,
  AccountAlertIcon,
  AddItemIcon,
  DataIcon,
  GaSymbol,
  CriteoIcon,
  DinRemIcon,
  AmoCrmBigIcon,
  GetCourseBigIcon,
  Bitrix24BigIcon,
  BitrixBigIcon,
  RetailCrmBigIcon,
  EnvyCrmBigIcon,
  UonCrmBigIcon,
  CustomCrmBigIcon,
  ComagicIcon,
  Pencile,
  MyTargetIcon,
  MegaplanIcon,
  CalltrackingByIcon,
} from '../components/app-icon/Icons'

const styles = theme => ({
  pageTemplate: {
    maxWidth: 1072,
    margin: '0 auto',
  },
  wizardRow: {
    padding: '0 24px',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    marginBottom: 32,
  },
  wizardContent: {
    maxWidth: 940,
    width: '100%',
  },
  header: {
    padding: '15px 40px 6px 22px',
  },
  content: {
    padding: '16px 40px 30px 22px',
  },

  viewList: {
    margin: 0,
    padding: 0,
  },

  list: {
    padding: 0,
    listStyleType: 'none',
  },
  item: {
    marginBottom: 12,
  },
  link: {
    display: 'inline-flex',
    alignItems: 'center',
    fontSize: 16,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 1.5,
    letterSpacing: 'normal',
    color: 'rgb(136, 102, 255)',
    '&:hover': {
      textDecoration: 'none',
    },
  },
  icon: {
    width: 40,
    height: 40,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: '0 16px 32px 0 rgba(0, 0, 0, 0.12)',
    backgroundColor: 'rgb(255, 204, 0)',
    borderRadius: '100%',
    marginRight: 15,
  },
  chanelList: {
    listStyleType: 'none',
    padding: 0,
    margin: 0,
  },
  chanel: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '13px 15px 13px 32px',
  },
  chanelInfo: {
    listStyleType: 'none',
    padding: 0,
    marginLeft: 8,
    marginRight: 65,
    flex: 1,
  },
  chanelTitle: {
    fontFamily: 'Roboto',
    fontSize: 14,
    color: 'rgba(0, 0, 0, 0.75)',
  },
  chanelStatus: {
    fontFamily: 'Roboto',
    fontSize: 10,
    lineHeight: 1.6,
    color: 'rgba(0, 0, 0, 0.5)',
  },
  chanelStatusIcon: {
    width: 16,
    height: 16,
  },

  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: theme.spacing.unit * 3,
    paddingBottom: theme.spacing.unit * 3,
    paddingLeft: theme.spacing.unit * 2,
    paddingRight: theme.spacing.unit * 2,
    [theme.breakpoints.up('md')]: {},
    '@media (min-width:960px)': {
      // eslint-disable-line no-useless-computed-key
      paddingLeft: theme.spacing.unit * 8,
      paddingRight: theme.spacing.unit * 8,
    },
  },
  link: {
    textDecoration: 'none',
  },
  toolbarInner: {
    padding: 0,
  },
  extendedIcon: {
    marginRight: 5,
  },
  container: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginLeft: 32,
    background: '#fff',
    borderRadius: 32,
  },
  info: {
    margin: 0,
    padding: 0,
    flex: 1,
  },
  siteIcon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 24,
    height: 24,
    margin: '0 19px 0 23px',
    color: '#fff',
    fontSize: 16,
    fontWeight: 600,
    borderRadius: '100%',
    backgroundColor: 'rgb(44, 50, 157)',
  },
  list: {
    margin: '0 0 16px 0',
    padding: '7px 20px 10px 40px',
    listStyleType: 'none',
    borderRadius: 4,
  },
  user: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 16,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 1.5,
    letterSpacing: 'normal',
    color: 'rgb(0, 0, 0)',
  },
  avatar: { width: 22, height: 22, marginRight: 10 },
  item: {
    position: 'relative',
    fontFamily: 'Roboto',
    fontSize: 12,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 1.33,
    letterSpacing: 'normal',
    color: 'rgb(0, 0, 0, .75)',
    '&::before': {
      content: '"↳"',
      marginRight: 5,
    },
  },
  dataIcon: {
    width: 16,
    height: 16,
    fill: 'rgba(0, 0, 0, .5)',
  },
  gaSymbol: {
    width: 36,
    height: 36,
  },
  chanelError: {
    backgroundColor: 'rgba(255, 59, 48, 0.1)',
  },
  chanelStatus: {
    fontFamily: 'Roboto',
    fontSize: 10,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 1.2,
    letterSpacing: 'normal',
    color: 'rgb(0, 0, 0, .5)',
  },
  chanelStatusError: {
    color: 'rgb(255, 59, 48)',
  },
  '@keyframes greyPulse': {
    '0%': {
      backgroundColor: 'grey',
    },
    '50%': {
      backgroundColor: '#BBB',
    },
    '100%': {
      backgroundColor: 'grey',
    },
  },
  '@keyframes trianglePulse': {
    '0%': {
      borderColor: 'grey transparent transparent transparent',
    },
    '50%': {
      borderColor: '#BBB transparent transparent transparent',
    },
    '100%': {
      borderColor: 'grey transparent transparent transparent',
    },
  },
  tooltip: {
    position: 'absolute',
    whiteSpace: 'pre-line',
    backgroundColor: '#000',
    color: '#fff',
    borderRadius: 4,
    fontSize: 14,
    padding: '5px 8px',
    top: -22,
    left: 24,
    zIndex: 10,
    animationName: 'greyPulse',
    animationIterationCount: 'infinite',
    animationDuration: '1.4s',
    '&::after': {
      content: '" "',
      position: 'absolute',
      bottom: 0,
      left: 31,
      width: 0,
      height: 0,
      borderStyle: 'solid',
      borderWidth: '7px 5px 0 5px',
      borderColor: '#000000 transparent transparent transparent',
      transform: 'translateY(100%)',
      animationName: 'trianglePulse',
      animationIterationCount: 'infinite',
      animationDuration: '1.4s',
    },
  },
  actions: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '20px',
  },
  actionTitle: {
    opacity: '0.5',
    fontFamily: 'Roboto',
    fontSize: '8px',
    fontWeight: '500',
  },
  crmData: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
  },

  crmStatisticWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginTop: '10px',
  },
  crmDescription: {
    opacity: '0.75',
    fontSize: '12px',
  },
  statisticData: {
    opacity: '0.5',
    fontFamily: 'Roboto',
    fontSize: '10px',
  },
  statisticTitle: {
    opacity: '0.75',
    fontFamily: 'Roboto',
    fontSize: '14px',
  },
  errors: {
    color: '#ff3b30',
    fontFamily: 'Roboto',
    fontSize: '10px',
  },
  linkCrm: {
    color: '#000',
  },
})

class Dashboard extends Component {
  state = {
    client: window.state.googleAnalyticsSettings.client,
    site: window.state.site,
    account: window.state.googleAnalyticsSettings.account,
    webProperty: window.state.googleAnalyticsSettings.webProperty,
    view: window.state.googleAnalyticsSettings.view,
    dataset: window.state.googleAnalyticsSettings.dataset,
    editUrl: window.state.googleAnalyticsSettings.editUrl,
    dataSources: window.state.dataSources,
    ecomWidget: window.state.ecom_widget,
    isEditedStatistics: window.state.hasEditedStatistics,
    isActiveDataSources: window.state.hasActiveDataSources,
    isEcomSetup: window.state.ecom_setup_is_confirmed,
    showEcomError: true,
    user: window.state.user,
  }

  handleBack = () => {
    location.href = this.state.editUrl
  }

  getCampaignsFilterString(campaignsFilter) {
    let stringArr = []
    for (let i in campaignsFilter) {
      stringArr.push(campaignsFilter[i].name)
    }
    if (stringArr.length > 3) {
      return stringArr.splice(0, 3).join(', ') + ' ...'
    }

    return stringArr.join(', ')
  }

  render() {
    const { classes } = this.props
    const {
      site,
      client,
      account,
      webProperty,
      view,
      dataset,
      dataSources,
      isEcomSetup,
      isEditedStatistics,
      isActiveDataSources,
      user,
    } = this.state

    const icon = type => {
      switch (type) {
        case 'yandex_market':
          return <YandexMarketIcon className={classes.ChanelIcon} />
        case 'yandex_direct':
          return <YandexDirectIcon className={classes.ChanelIcon} />
        case 'google_ads':
          return <GoogleAdsIcon className={classes.ChanelIcon} />
        case 'vkontakte':
          return <VkIcon className={classes.ChanelIcon} />
        case 'criteo':
          return <CriteoIcon className={classes.ChanelIcon} />
        case 'dinrem':
          return <DinRemIcon className={classes.ChanelIcon} />
        case 'facebook':
          return <FbIcon className={classes.ChanelIcon} />
        case 'mytarget':
          return <MyTargetIcon className={classes.ChanelIcon} />
        default:
          break
      }
    }

    const statusSymbol = type => {
      switch (type) {
        case 'wait':
          return <AccountWaitIcon className={classes.chanelStatusIcon} />
        case 'ok':
          return <AccountIdentifierIcon className={classes.chanelStatusIcon} />
        case 'error':
          return <AccountAlertIcon className={classes.chanelStatusIcon} />
        default:
          break
      }
    }

    const viewColor = () => {
      if (!state.selectedView) {
        return '#ff3b30'
      } else {
        return 'rgb(0, 0, 0)'
      }
    }

    const Project = () => (
      <a
        className={classes.container}
        href={`http://${site.url.replace(/(http|https):\/\//is, '')}`}
        target="_blank"
      >
        <div className={classes.siteIcon}>S</div>
        <ul className={classes.info}>
          <Typography component="li" variant="body1">
            {site.url}
          </Typography>
          <Typography component="li" variant="overline">
            {site.name}
          </Typography>
        </ul>
      </a>
    )

    const getAmoStatusesWithPipelinesString = () => {
      if (!window.state.amoCrm) {
        return false
      }

      const account = window.state.amoCrm.settings

      if (!account.pipelines) {
        return '[?]'
      }

      let statuses = []

      for (var i in account.pipelines) {
        var pip = account.pipelines[i]

        if (!pip.statuses) {
          continue
        }

        for (var j in pip.statuses) {
          statuses.push(pip.statuses[j].name + ' (воронка "' + pip.name + '")')
        }
      }

      if (!statuses.length) {
        return '[?]'
      }

      if (statuses.length > 3) {
        return statuses.slice(0, 3).join(', ') + ' и другие'
      }

      return statuses.join(', ')
    }

    const getEnvyStatusesWithPipelinesString = () => {
      if (!window.state.envyCrm) {
        return false
      }

      const account = window.state.envyCrm.settings

      if (!account.pipelines) {
        return '[?]'
      }

      let statuses = []

      for (var i in account.pipelines) {
        var pip = account.pipelines[i]

        if (!pip.statuses) {
          continue
        }

        for (var j in pip.statuses) {
          statuses.push(pip.statuses[j].name + ' (воронка "' + pip.name + '")')
        }
      }

      if (!statuses.length) {
        return '[?]'
      }

      if (statuses.length > 3) {
        return statuses.slice(0, 3).join(', ') + ' и другие'
      }

      return statuses.join(', ')
    }

    return (
      <Fragment>
        <LicenseExpired>
          <ActionsForUsing />
        </LicenseExpired>

        <div className={classes.pageTemplate}>
          <AppBar
            position="static"
            color="inherit"
            elevation={0}
            style={{ padding: '24px' }}
          >
            <Toolbar className={classes.toolbarInner}>
              <LogoData />
              <Project />
              <TraficLight />
            </Toolbar>
          </AppBar>

          {!user.agree_with_offer_date && <AcceptTerm />}

          <CustomizeAll />

          <div className={classes.wizardRow}>
            <LeftNavigationDashboard />

            <div className={classes.wizardContent}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                }}
              >
                <div style={{ width: 400 }}>
                  <MarketingDashboard project={<Project />} />

                  {isActiveDataSources || isEditedStatistics ? (
                    <Wrapper
                      shadow={1}
                      style={{
                        borderRadius: 8,
                        overflow: 'hidden',
                      }}
                    >
                      <div
                        style={{
                          marginBottom: 6,
                          padding: '16px 11px 0 32px',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          position: 'relative',
                        }}
                      >
                        <Typography
                          style={{
                            fontSize: 9,
                            fontWeight: 500,
                            fontStyle: 'normal',
                            fontStretch: 'normal',
                            letterSpacing: 2,
                            color: '#000000',
                            textTransform: 'uppercase',
                          }}
                        >
                          Автоматическая загрузка рекламных расходов
                        </Typography>
                        <a href={dataSources.addUrl}>
                          <button
                            style={{
                              border: 0,
                              width: 24,
                              height: 24,
                              padding: 0,
                              cursor: 'pointer',
                              outline: 'none',
                              background: 'transparent',
                            }}
                          >
                            <AddItemIcon />
                          </button>
                        </a>
                      </div>
                      <ul className={classes.chanelList}>
                        {dataSources.items.map(source => {
                          return (
                            <li
                              key={source.hash}
                              className={cx(classes.chanel, {
                                [classes.chanelError]:
                                  source.status === 'error',
                              })}
                            >
                              <div style={{ width: 36, height: 36 }}>
                                {icon(source.type)}
                              </div>
                              <ul className={classes.chanelInfo}>
                                <li className={classes.chanelTitle}>
                                  {source.displayName}
                                </li>
                                <li
                                  className={cx(classes.chanelStatus, {
                                    [classes.chanelStatusError]:
                                      source.status === 'error',
                                  })}
                                >
                                  {source.statusText}
                                  {['yandex_direct', 'google_ads'].indexOf(
                                    source.type
                                  ) > -1 && !source.hasAuthError ? (
                                    <span
                                      style={{ display: 'block', marginTop: 5 }}
                                    >
                                      {source.campaignsFilter ? (
                                        <div>
                                          Данные по затратам будут получены по
                                          выбранным кампаниям:{' '}
                                          {this.getCampaignsFilterString(
                                            source.campaignsFilter
                                          )}
                                        </div>
                                      ) : (
                                        <div>
                                          Данные по затратам будут получены по
                                          всем кампаниям.
                                        </div>
                                      )}
                                    </span>
                                  ) : null}
                                </li>
                              </ul>
                              {statusSymbol(source.status)}
                            </li>
                          )
                        })}
                      </ul>
                    </Wrapper>
                  ) : (
                    <MessageBoard />
                  )}

                  {isEcomSetup ? (
                    <EcomModuleDashboard
                      showEcomError={this.state.showEcomError}
                    />
                  ) : (
                    ''
                  )}
                  {state.amoCrm.settings ||
                  state.bitrix24.settings ||
                  state.retailCrm.settings ||
                  state.bitrix.settings ||
                  state.envyCrm.settings ||
                  state.comagic.settings ||
                  state.uon.settings ||
                  state.getcourse.settings ||
                  state.custom.settings
                    ? ''
                    : ''}
                  {state.amoCrm.settings ? (
                    <a
                      href="/crm/amo"
                      style={{
                        color: '#000',
                      }}
                    >
                      <Wrapper
                        shadow={2}
                        style={{
                          padding: '20px 16px 20px 20px',
                          borderRadius: 8,
                          overflow: 'hidden',
                          marginTop: 32,
                          backgroundColor: 'rgba(255, 255, 255, 0.04)',
                        }}
                      >
                        <div className={classes.actions}>
                          <span className={classes.actionTitle}>
                            АВТОМАТИЧЕСКАЯ ЗАГРУЗКА ДАННЫХ ИЗ CRM
                          </span>
                          <Pencile />
                        </div>
                        <div className={classes.crmData}>
                          <div>
                            <AmoCrmBigIcon height="22" />
                            <div>
                              <a
                                className={classes.linkCrm}
                                href={
                                  'https://' +
                                  state.amoCrm.settings.subdomain +
                                  '.amocrm.com'
                                }
                              >
                                {state.amoCrm.settings.subdomain}.amocrm.com
                              </a>
                            </div>

                            <div className={classes.crmStatisticWrapper}>
                              <div className={classes.crmStatistic}>
                                <div className={classes.statisticTitle}>
                                  Куда отправлять данные
                                </div>
                                <div className={classes.statisticData}>
                                  {state.amoCrm.settings &&
                                  state.amoCrm.settings.import_destination ==
                                    'ecom'
                                    ? 'Покупки в электронной торговле'
                                    : ''}

                                  {state.amoCrm.settings &&
                                  state.amoCrm.settings.import_destination ==
                                    'event'
                                    ? 'Создать цель "Успешные продажи"'
                                    : ''}
                                </div>
                              </div>
                            </div>

                            <div className={classes.crmStatisticWrapper}>
                              <div className={classes.crmStatistic}>
                                <div className={classes.statisticTitle}>
                                  Выбранные статусы сделок
                                </div>
                                <div className={classes.statisticData}>
                                  {getAmoStatusesWithPipelinesString()}
                                </div>
                              </div>
                            </div>

                            <div className={classes.crmStatisticWrapper}>
                              <div className={classes.crmStatistic}>
                                <div className={classes.statisticTitle}>
                                  Последняя отправка данных
                                </div>
                                <div className={classes.statisticData}>
                                  {state.amoCrm.data &&
                                  (!state.amoCrm.error ||
                                    !state.amoCrm.error.text)
                                    ? state.amoCrm.data.updated_at
                                    : ''}
                                </div>
                                {state.amoCrm.error &&
                                state.amoCrm.error.text ? (
                                  <div className={classes.errors}>
                                    {state.amoCrm.error.text}
                                    {state.amoCrm.error.date ? (
                                      <div>
                                        <br />
                                        Данные не выгружаются с:{' '}
                                        {state.amoCrm.error.date}
                                      </div>
                                    ) : (
                                      <div>
                                        <br />
                                        Нет данных
                                      </div>
                                    )}
                                  </div>
                                ) : (
                                  ''
                                )}
                                {!state.amoCrm.data &&
                                (!state.amoCrm.error ||
                                  !state.amoCrm.error.text) ? (
                                  <div className={classes.statisticData}>
                                    Данные по продажам пока не поступали
                                  </div>
                                ) : (
                                  ''
                                )}
                              </div>
                            </div>
                          </div>
                          {state.amoCrm.isAvailable ? (
                            <AccountIdentifierIcon
                              className={classes.chanelStatusIcon}
                            />
                          ) : (
                            <div>
                              <AccountAlertIcon
                                className={classes.chanelStatusIcon}
                              />
                            </div>
                          )}
                        </div>
                      </Wrapper>
                    </a>
                  ) : (
                    ''
                  )}
                  {state.getcourse.settings ? (
                    <a
                      href="/getcourse/connect/form"
                      style={{
                        color: '#000',
                      }}
                    >
                      <Wrapper
                        shadow={2}
                        style={{
                          padding: '20px 16px 20px 20px',
                          borderRadius: 8,
                          overflow: 'hidden',
                          marginTop: 32,
                          backgroundColor: 'rgba(255, 255, 255, 0.04)',
                        }}
                      >
                        <div className={classes.actions}>
                          <span className={classes.actionTitle}>
                            АВТОМАТИЧЕСКАЯ ЗАГРУЗКА ДАННЫХ ИЗ CRM
                          </span>
                          <Pencile />
                        </div>
                        <div className={classes.crmData}>
                          <div>
                            <GetCourseBigIcon height="22" />

                            <div className={classes.crmStatisticWrapper}>
                              <div className={classes.crmStatistic}>
                                <div className={classes.statisticTitle}>
                                  Последняя отправка данных
                                </div>
                                <div className={classes.statisticData}>
                                  {state.getcourse.data &&
                                  (!state.getcourse.error ||
                                    !state.getcourse.error.text)
                                    ? state.getcourse.data.updated_at
                                    : ''}
                                </div>
                                {state.getcourse.error &&
                                state.getcourse.error.text ? (
                                  <div className={classes.errors}>
                                    {state.getcourse.error.text}
                                    {state.getcourse.error.date ? (
                                      <div>
                                        <br />
                                        Данные не выгружаются с:{' '}
                                        {state.getcourse.error.date}
                                      </div>
                                    ) : (
                                      <div>
                                        <br />
                                        Нет данных
                                      </div>
                                    )}
                                  </div>
                                ) : (
                                  ''
                                )}
                                {!state.getcourse.data &&
                                (!state.getcourse.error ||
                                  !state.getcourse.error.text) ? (
                                  <div className={classes.statisticData}>
                                    Данные по продажам пока не поступали
                                  </div>
                                ) : (
                                  ''
                                )}
                              </div>
                            </div>
                          </div>
                          {state.getcourse.isAvailable ? (
                            <AccountIdentifierIcon
                              className={classes.chanelStatusIcon}
                            />
                          ) : (
                            <div>
                              <AccountAlertIcon
                                className={classes.chanelStatusIcon}
                              />
                            </div>
                          )}
                        </div>
                      </Wrapper>
                    </a>
                  ) : (
                    ''
                  )}
                  {state.bitrix24.settings ? (
                    <a
                      href="/crm/bitrix24"
                      style={{
                        color: '#000',
                      }}
                    >
                      <Wrapper
                        shadow={2}
                        style={{
                          padding: '20px 16px 20px 20px',
                          borderRadius: 8,
                          overflow: 'hidden',
                          marginTop: 32,
                          backgroundColor: 'rgba(255, 255, 255, 0.04)',
                        }}
                      >
                        <div className={classes.actions}>
                          <span className={classes.actionTitle}>
                            АВТОМАТИЧЕСКАЯ ЗАГРУЗКА ДАННЫХ ИЗ CRM
                          </span>
                          <Pencile />
                        </div>
                        <div className={classes.crmData}>
                          <div>
                            <Bitrix24BigIcon height="22" />
                            <div>
                              <a
                                className={classes.linkCrm}
                                href={
                                  state.bitrix24.settings.endpoint.split(
                                    '/rest/'
                                  )[0]
                                }
                              >
                                {
                                  state.bitrix24.settings.endpoint.split(
                                    '/rest/'
                                  )[0]
                                }
                              </a>
                            </div>

                            <div className={classes.crmStatisticWrapper}>
                              <div className={classes.crmStatistic}>
                                <div className={classes.statisticTitle}>
                                  Куда отправлять данные
                                </div>
                                <div className={classes.statisticData}>
                                  {state.bitrix24.settings &&
                                  state.bitrix24.settings.import_destination ==
                                    'ecom'
                                    ? 'Покупки в электронной торговле'
                                    : ''}

                                  {state.bitrix24.settings &&
                                  state.bitrix24.settings.import_destination ==
                                    'event'
                                    ? 'Создать цель "Успешные продажи"'
                                    : ''}
                                </div>
                              </div>
                            </div>

                            <div className={classes.crmStatisticWrapper}>
                              <div className={classes.crmStatistic}>
                                <div className={classes.statisticTitle}>
                                  Выбранные статусы сделок
                                </div>
                                <div className={classes.statisticData}>
                                  {state.bitrix24.statuses &&
                                    state.bitrix24.statuses.map(source => {
                                      return source + ' '
                                    })}
                                </div>
                              </div>
                            </div>

                            <div className={classes.crmStatisticWrapper}>
                              <div className={classes.crmStatistic}>
                                <div className={classes.statisticTitle}>
                                  Последняя отправка данных
                                </div>
                                <div className={classes.statisticData}>
                                  {state.bitrix24.data &&
                                  (!state.bitrix24.error ||
                                    !state.bitrix24.error.text)
                                    ? state.bitrix24.data.updated_at
                                    : ''}
                                </div>
                                {state.bitrix24.error &&
                                state.bitrix24.error.text ? (
                                  <div className={classes.errors}>
                                    {state.bitrix24.error.text}
                                    {state.bitrix24.error.date ? (
                                      <div>
                                        <br />
                                        Данные не выгружаются с:{' '}
                                        {state.bitrix24.error.date}
                                      </div>
                                    ) : (
                                      <div>
                                        <br />
                                        Нет данных
                                      </div>
                                    )}
                                  </div>
                                ) : (
                                  ''
                                )}
                                {!state.bitrix24.data &&
                                (!state.bitrix24.error ||
                                  !state.bitrix24.error.text) ? (
                                  <div className={classes.statisticData}>
                                    Данные по продажам пока не поступали
                                  </div>
                                ) : (
                                  ''
                                )}
                              </div>
                            </div>
                          </div>
                          {state.bitrix24.isAvailable ? (
                            <AccountIdentifierIcon
                              className={classes.chanelStatusIcon}
                            />
                          ) : (
                            <div>
                              <AccountAlertIcon
                                className={classes.chanelStatusIcon}
                              />
                            </div>
                          )}
                        </div>
                      </Wrapper>
                    </a>
                  ) : (
                    ''
                  )}

                  {state.yclients.settings ? (
                    <a
                      href="/crm/yclients"
                      style={{
                        color: '#000',
                      }}
                    >
                      <Wrapper
                        shadow={2}
                        style={{
                          padding: '20px 16px 20px 20px',
                          borderRadius: 8,
                          overflow: 'hidden',
                          marginTop: 32,
                          backgroundColor: 'rgba(255, 255, 255, 0.04)',
                        }}
                      >
                        <div className={classes.actions}>
                          <span className={classes.actionTitle}>
                            АВТОМАТИЧЕСКАЯ ЗАГРУЗКА ДАННЫХ ИЗ CRM
                          </span>
                          <Pencile />
                        </div>
                        <div className={classes.crmData}>
                          <div>
                            <img src="/images/crm/yclients/logo.png"></img>
                            <div className={classes.crmStatisticWrapper}>
                              <div className={classes.crmStatistic}>
                                <div className={classes.statisticTitle}>
                                  Куда отправлять данные
                                </div>
                                <div className={classes.statisticData}>
                                  {state.yclients.settings &&
                                  state.yclients.settings.destination ==
                                  'ecom'
                                    ? 'Покупки в электронной торговле'
                                    : ''}

                                  {state.yclients.settings &&
                                  state.yclients.settings.destination ==
                                  'event'
                                    ? 'Создать цель "Успешные продажи"'
                                    : ''}
                                </div>
                              </div>
                            </div>

                            <div className={classes.crmStatisticWrapper}>
                              <div className={classes.crmStatistic}>
                                <div className={classes.statisticTitle}>
                                  Филиалы:
                                </div>
                                <div className={classes.statisticData}>
                                  {state.yclients.statuses &&
                                  state.yclients.statuses.map(source => {
                                    return source + ' '
                                  })}
                                </div>
                              </div>
                            </div>

                            <div className={classes.crmStatisticWrapper}>
                              <div className={classes.crmStatistic}>
                                <div className={classes.statisticTitle}>
                                  Последняя отправка данных
                                </div>
                                <div className={classes.statisticData}>
                                  {state.yclients.data &&
                                  (!state.yclients.error ||
                                    !state.yclients.error.text)
                                    ? state.yclients.data.updated_at
                                    : ''}
                                </div>
                                {state.yclients.error &&
                                state.yclients.error.text ? (
                                  <div className={classes.errors}>
                                    {state.yclients.error.text}
                                    {state.yclients.error.date ? (
                                      <div>
                                        <br />
                                        Данные не выгружаются с:{' '}
                                        {state.yclients.error.date}
                                      </div>
                                    ) : (
                                      <div>
                                        <br />
                                        Нет данных
                                      </div>
                                    )}
                                  </div>
                                ) : (
                                  ''
                                )}
                                {!state.yclients.data &&
                                (!state.yclients.error ||
                                  !state.yclients.error.text) ? (
                                  <div className={classes.statisticData}>
                                    Данные по продажам пока не поступали
                                  </div>
                                ) : (
                                  ''
                                )}
                              </div>
                            </div>
                          </div>
                          {state.yclients.isAvailable ? (
                            <AccountIdentifierIcon
                              className={classes.chanelStatusIcon}
                            />
                          ) : (
                            <div>
                              <AccountAlertIcon
                                className={classes.chanelStatusIcon}
                              />
                            </div>
                          )}
                        </div>
                      </Wrapper>
                    </a>
                  ) : (
                    ''
                  )}

                  {state.megaplan.settings ? (
                    <a
                      href="/crm/megaplan"
                      style={{
                        color: '#000',
                      }}
                    >
                      <Wrapper
                        shadow={2}
                        style={{
                          padding: '20px 16px 20px 20px',
                          borderRadius: 8,
                          overflow: 'hidden',
                          marginTop: 32,
                          backgroundColor: 'rgba(255, 255, 255, 0.04)',
                        }}
                      >
                        <div className={classes.actions}>
                          <span className={classes.actionTitle}>
                            АВТОМАТИЧЕСКАЯ ЗАГРУЗКА ДАННЫХ ИЗ CRM
                          </span>
                          <Pencile />
                        </div>
                        <div className={classes.crmData}>
                          <div>
                            <MegaplanIcon height={20} />
                            <div>
                              <a
                                className={classes.linkCrm}
                                href={state.megaplan.settings.url}
                              >
                                {state.megaplan.settings.url}
                              </a>
                            </div>

                            <div className={classes.crmStatisticWrapper}>
                              <div className={classes.crmStatistic}>
                                <div className={classes.statisticTitle}>
                                  Куда отправлять данные
                                </div>
                                <div className={classes.statisticData}>
                                  {state.megaplan.settings &&
                                  state.megaplan.settings.import_destination ==
                                    'ecom'
                                    ? 'Покупки в электронной торговле'
                                    : ''}

                                  {state.megaplan.settings &&
                                  state.megaplan.settings.import_destination ==
                                    'event'
                                    ? 'Создать цель "Успешные продажи"'
                                    : ''}
                                </div>
                              </div>
                            </div>

                            <div className={classes.crmStatisticWrapper}>
                              <div className={classes.crmStatistic}>
                                <div className={classes.statisticTitle}>
                                  Выбранные статусы сделок
                                </div>
                                <div className={classes.statisticData}>
                                  {state.megaplan.statuses &&
                                    state.megaplan.statuses.map(source => {
                                      return source + ' '
                                    })}
                                </div>
                              </div>
                            </div>

                            <div className={classes.crmStatisticWrapper}>
                              <div className={classes.crmStatistic}>
                                <div className={classes.statisticTitle}>
                                  Последняя отправка данных
                                </div>
                                <div className={classes.statisticData}>
                                  {state.megaplan.data &&
                                  (!state.megaplan.error ||
                                    !state.megaplan.error.text)
                                    ? state.megaplan.data.updated_at
                                    : ''}
                                </div>
                                {state.megaplan.error &&
                                state.megaplan.error.text ? (
                                  <div className={classes.errors}>
                                    {state.megaplan.error.text}
                                    {state.megaplan.error.date ? (
                                      <div>
                                        <br />
                                        Данные не выгружаются с:{' '}
                                        {state.megaplan.error.date}
                                      </div>
                                    ) : (
                                      <div>
                                        <br />
                                        Нет данных
                                      </div>
                                    )}
                                  </div>
                                ) : (
                                  ''
                                )}
                                {!state.megaplan.data &&
                                (!state.megaplan.error ||
                                  !state.megaplan.error.text) ? (
                                  <div className={classes.statisticData}>
                                    Данные по продажам пока не поступали
                                  </div>
                                ) : (
                                  ''
                                )}
                              </div>
                            </div>
                          </div>
                          {state.megaplan.isAvailable ? (
                            <AccountIdentifierIcon
                              className={classes.chanelStatusIcon}
                            />
                          ) : (
                            <div>
                              <AccountAlertIcon
                                className={classes.chanelStatusIcon}
                              />
                            </div>
                          )}
                        </div>
                      </Wrapper>
                    </a>
                  ) : (
                    ''
                  )}

                  {state.retailCrm.settings ? (
                    <a
                      href="/crm/retail"
                      style={{
                        color: '#000',
                      }}
                    >
                      <Wrapper
                        shadow={2}
                        style={{
                          padding: '20px 16px 20px 20px',
                          borderRadius: 8,
                          overflow: 'hidden',
                          marginTop: 32,
                          backgroundColor: 'rgba(255, 255, 255, 0.04)',
                        }}
                      >
                        <div className={classes.actions}>
                          <span className={classes.actionTitle}>
                            АВТОМАТИЧЕСКАЯ ЗАГРУЗКА ДАННЫХ ИЗ CRM
                          </span>
                          <Pencile />
                        </div>
                        <div className={classes.crmData}>
                          <div>
                            <RetailCrmBigIcon height="22" />
                            <div>{state.retailCrm.settings.endpoint}</div>

                            <div className={classes.crmStatisticWrapper}>
                              <div className={classes.crmStatistic}>
                                <div className={classes.statisticTitle}>
                                  Куда отправлять данные
                                </div>
                                <div className={classes.statisticData}>
                                  {state.retailCrm.settings &&
                                  state.retailCrm.settings.import_destination ==
                                    'ecom'
                                    ? 'Покупки в электронной торговле'
                                    : ''}

                                  {state.retailCrm.settings &&
                                  state.retailCrm.settings.import_destination ==
                                    'event'
                                    ? 'Создать цель "Успешные продажи"'
                                    : ''}
                                </div>
                              </div>
                            </div>

                            <div className={classes.crmStatisticWrapper}>
                              <div className={classes.crmStatistic}>
                                <div className={classes.statisticTitle}>
                                  Выбранные статусы сделок
                                </div>
                                <div className={classes.statisticData}>
                                  {state.retailCrm.statuses
                                    ? state.retailCrm.statuses.map(source => {
                                        return source + ' '
                                      })
                                    : ''}
                                </div>
                              </div>
                            </div>

                            <div className={classes.crmStatisticWrapper}>
                              <div className={classes.crmStatistic}>
                                <div className={classes.statisticTitle}>
                                  Статус возвратов
                                </div>
                                <div className={classes.statisticData}>
                                  {state.retailCrm.settings.cancel_status &&
                                  state.retailCrm.settings.cancel_status
                                    ? state.retailCrm.settings.cancel_status
                                    : '-'}
                                </div>
                              </div>
                            </div>

                            <div className={classes.crmStatisticWrapper}>
                              <div className={classes.crmStatistic}>
                                <div className={classes.statisticTitle}>
                                  Последняя отправка данных
                                </div>
                                <div className={classes.statisticData}>
                                  {state.retailCrm.data &&
                                  (!state.retailCrm.error ||
                                    !state.retailCrm.error.text)
                                    ? state.retailCrm.data.updated_at
                                    : ''}
                                </div>
                                {state.retailCrm.error &&
                                state.retailCrm.error.text ? (
                                  <div className={classes.errors}>
                                    {state.retailCrm.error.text}
                                    {state.retailCrm.error.date ? (
                                      <div>
                                        <br />
                                        Данные не выгружаются с:{' '}
                                        {state.retailCrm.error.date}
                                      </div>
                                    ) : (
                                      <div>
                                        <br />
                                        Нет данных
                                      </div>
                                    )}
                                  </div>
                                ) : (
                                  ''
                                )}
                                {!state.retailCrm.data &&
                                (!state.retailCrm.error ||
                                  !state.retailCrm.error.text) ? (
                                  <div className={classes.statisticData}>
                                    Данные по продажам пока не поступали
                                  </div>
                                ) : (
                                  ''
                                )}
                              </div>
                            </div>
                          </div>
                          {state.retailCrm.isAvailable ? (
                            <AccountIdentifierIcon
                              className={classes.chanelStatusIcon}
                            />
                          ) : (
                            <div>
                              <AccountAlertIcon
                                className={classes.chanelStatusIcon}
                              />
                            </div>
                          )}
                        </div>
                      </Wrapper>
                    </a>
                  ) : (
                    ''
                  )}
                  {state.envyCrm.settings ? (
                    <a
                      href="/crm/envy"
                      style={{
                        color: '#000',
                      }}
                    >
                      <Wrapper
                        shadow={2}
                        style={{
                          padding: '20px 16px 20px 20px',
                          borderRadius: 8,
                          overflow: 'hidden',
                          marginTop: 32,
                          backgroundColor: 'rgba(255, 255, 255, 0.04)',
                        }}
                      >
                        <div className={classes.actions}>
                          <span className={classes.actionTitle}>
                            АВТОМАТИЧЕСКАЯ ЗАГРУЗКА ДАННЫХ ИЗ CRM
                          </span>
                          <Pencile />
                        </div>
                        <div className={classes.crmData}>
                          <div>
                            <EnvyCrmBigIcon height="22" />
                            <div>{state.envyCrm.settings.endpoint}</div>

                            <div className={classes.crmStatisticWrapper}>
                              <div className={classes.crmStatistic}>
                                <div className={classes.statisticTitle}>
                                  Куда отправлять данные
                                </div>
                                <div className={classes.statisticData}>
                                  {state.envyCrm.settings &&
                                  state.envyCrm.settings.import_destination ==
                                    'ecom'
                                    ? 'Покупки в электронной торговле'
                                    : ''}

                                  {state.envyCrm.settings &&
                                  state.envyCrm.settings.import_destination ==
                                    'event'
                                    ? 'Создать цель "Успешные продажи"'
                                    : ''}
                                </div>
                              </div>
                            </div>

                            <div className={classes.crmStatisticWrapper}>
                              <div className={classes.crmStatistic}>
                                <div className={classes.statisticTitle}>
                                  Выбранные статусы сделок
                                </div>
                                <div className={classes.statisticData}>
                                  {getEnvyStatusesWithPipelinesString()}
                                </div>
                              </div>
                            </div>

                            <div className={classes.crmStatisticWrapper}>
                              <div className={classes.crmStatistic}>
                                <div className={classes.statisticTitle}>
                                  Последняя отправка данных
                                </div>
                                <div className={classes.statisticData}>
                                  {state.envyCrm.data &&
                                  (!state.envyCrm.error ||
                                    !state.envyCrm.error.text)
                                    ? state.envyCrm.data.updated_at
                                    : ''}
                                </div>
                                {state.envyCrm.error &&
                                state.envyCrm.error.text ? (
                                  <div className={classes.errors}>
                                    {state.envyCrm.error.text}
                                    {state.envyCrm.error.date ? (
                                      <div>
                                        <br />
                                        Данные не выгружаются с:{' '}
                                        {state.envyCrm.error.date}
                                      </div>
                                    ) : (
                                      <div>
                                        <br />
                                        Нет данных
                                      </div>
                                    )}
                                  </div>
                                ) : (
                                  ''
                                )}
                                {!state.envyCrm.data &&
                                (!state.envyCrm.error ||
                                  !state.envyCrm.error.text) ? (
                                  <div className={classes.statisticData}>
                                    Данные по продажам пока не поступали
                                  </div>
                                ) : (
                                  ''
                                )}
                              </div>
                            </div>
                          </div>
                          {state.envyCrm.isAvailable ? (
                            <AccountIdentifierIcon
                              className={classes.chanelStatusIcon}
                            />
                          ) : (
                            <div>
                              <AccountAlertIcon
                                className={classes.chanelStatusIcon}
                              />
                            </div>
                          )}
                        </div>
                      </Wrapper>
                    </a>
                  ) : (
                    ''
                  )}

                  {state.bitrix.settings ? (
                    <a
                      href="/crm/bitrix"
                      style={{
                        color: '#000',
                      }}
                    >
                      <Wrapper
                        shadow={2}
                        style={{
                          padding: '20px 16px 20px 20px',
                          borderRadius: 8,
                          overflow: 'hidden',
                          marginTop: 32,
                          backgroundColor: 'rgba(255, 255, 255, 0.04)',
                        }}
                      >
                        <div className={classes.actions}>
                          <span className={classes.actionTitle}>
                            АВТОМАТИЧЕСКАЯ ЗАГРУЗКА ДАННЫХ ИЗ CRM
                          </span>
                          <Pencile />
                        </div>
                        <div className={classes.crmData}>
                          <div>
                            <BitrixBigIcon height="22" />
                            {/* <div>Код активации: {state.bitrix.settings.hash}</div> */}

                            <div className={classes.crmStatisticWrapper}>
                              <div className={classes.crmStatistic}>
                                <div className={classes.statisticTitle}>
                                  Последняя отправка данных
                                </div>
                                <div className={classes.statisticData}>
                                  {state.bitrix.data &&
                                  (!state.bitrix.error ||
                                    !state.bitrix.error.text)
                                    ? state.bitrix.data.updated_at
                                    : ''}
                                </div>
                                {state.bitrix.error &&
                                state.bitrix.error.text ? (
                                  <div className={classes.errors}>
                                    {state.bitrix.error.text}
                                    {state.bitrix.error.date ? (
                                      <div>
                                        <br />
                                        Данные не выгружаются с:{' '}
                                        {state.bitrix.error.date}
                                      </div>
                                    ) : (
                                      <div>
                                        <br />
                                        Нет данных
                                      </div>
                                    )}
                                  </div>
                                ) : (
                                  ''
                                )}
                                {!state.bitrix.data &&
                                (!state.bitrix.error ||
                                  !state.bitrix.error.text) ? (
                                  <div className={classes.statisticData}>
                                    Данные по продажам пока не поступали
                                  </div>
                                ) : (
                                  ''
                                )}
                              </div>
                            </div>
                          </div>
                          {state.bitrix.isAvailable ? (
                            <AccountIdentifierIcon
                              className={classes.chanelStatusIcon}
                            />
                          ) : (
                            <div>
                              <AccountAlertIcon
                                className={classes.chanelStatusIcon}
                              />
                            </div>
                          )}
                        </div>
                      </Wrapper>
                    </a>
                  ) : (
                    ''
                  )}
                </div>
                <div style={{ width: 400, marginLeft: 32 }}>
                  <BannerDailyReport />

                  <Wrapper
                    shadow={1}
                    style={{
                      borderRadius: 8,
                      overflow: 'hidden',
                    }}
                  >
                    <div
                      style={{
                        marginBottom: 25,
                        padding: '16px 11px 0 32px',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        position: 'relative',
                      }}
                    >
                      <Typography
                        style={{
                          fontSize: 9,
                          fontWeight: 500,
                          fontStyle: 'normal',
                          fontStretch: 'normal',
                          letterSpacing: 2,
                          color: '#000000',
                          textTransform: 'uppercase',
                        }}
                      >
                        настройки Google аналитики
                      </Typography>
                      <ButtonEdit
                        style={{
                          position: 'absolute',
                          right: 0,
                          top: 0,
                        }}
                        handleClick={this.handleBack}
                      />
                    </div>
                    <div className={classes.list}>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                        }}
                      >
                        <div className={classes.user}>
                          <Avatar
                            alt={client.username}
                            src={client.avatar}
                            className={classes.avatar}
                          />
                          <span
                            style={{
                              fontFamily: 'Roboto',
                              fontSize: 12,
                              fontWeight: 'normal',
                              fontStyle: 'normal',
                              fontStretch: 'normal',
                              lineHeight: 1.33,
                              letterSpacing: 'normal',
                              color: 'rgb(0, 0, 0)',
                            }}
                          >
                            {client.username}
                          </span>
                        </div>
                        {client.hasAuthError || client.hasSettingsError ? (
                          <AccountAlertIcon
                            className={classes.chanelStatusIcon}
                          />
                        ) : (
                          <AccountIdentifierIcon
                            className={classes.chanelStatusIcon}
                          />
                        )}
                      </div>
                      <div style={{ display: 'flex', margin: '30px 0' }}>
                        <GaSymbol className={classes.gaSymbol} />
                        <div style={{ marginTop: 10 }}>
                          <div
                            style={{
                              fontSize: 18,
                              lineHeight: 1.5,
                              color: viewColor(),
                            }}
                          >
                            {view.name}
                          </div>
                          <Typography className={classes.item} variant="body1">
                            {`${account.name}(${webProperty.id})`}
                          </Typography>
                        </div>
                      </div>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          marginBottom: 8,
                        }}
                      >
                        <DataIcon className={classes.dataIcon} />
                        <span
                          style={{
                            marginLeft: 16,
                            fontFamily: 'Roboto',
                            fontSize: 12,
                            lineHeight: 1.33,
                            color: 'rgb(0, 0, 0, 0.75)',
                          }}
                        >
                          {`Набор "${dataset.name}"`}
                        </span>
                      </div>
                      <div style={{ marginLeft: 33 }}>
                        <Typography
                          style={{
                            fontFamily: 'Roboto',
                            fontSize: 8,
                            fontWeight: 600,
                            fontStyle: 'normal',
                            fontStretch: 'normal',
                            lineHeight: 2,
                            letterSpacing: 1,
                            color: 'rgb(0, 0, 0, .5)',
                            textTransform: 'uppercase',
                          }}
                        >
                          Связанные представления:
                        </Typography>
                        {dataset.linkedViews &&
                          dataset.linkedViews.map(link => (
                            <Typography
                              key={link.id}
                              className={classes.item}
                              variant="body1"
                            >
                              {link.name}
                            </Typography>
                          ))}
                      </div>
                    </div>
                  </Wrapper>

                  {state.comagic.settings ? (
                    <a
                      href="/calltracking/comagic"
                      style={{
                        color: '#000',
                      }}
                    >
                      <Wrapper
                        shadow={2}
                        style={{
                          padding: '20px 16px 20px 20px',
                          borderRadius: 8,
                          overflow: 'hidden',
                          marginTop: 32,
                          backgroundColor: 'rgba(255, 255, 255, 0.04)',
                        }}
                      >
                        <div className={classes.actions}>
                          <span className={classes.actionTitle}>
                            АВТОМАТИЧЕСКАЯ ЗАГРУЗКА ДАННЫХ ИЗ КОЛЛТРЕКИНГА
                          </span>
                          <Pencile />
                        </div>
                        <div className={classes.crmData}>
                          <div>
                            <ComagicIcon height="22" />
                            {/* <div>Код активации: {state.bitrix.settings.hash}</div> */}

                            <div className={classes.crmStatisticWrapper}>
                              <div className={classes.crmStatistic}>
                                <div className={classes.statisticTitle}>
                                  Последняя отправка данных
                                </div>
                                <div className={classes.statisticData}>
                                  {state.comagic.data &&
                                  (!state.comagic.error ||
                                    !state.comagic.error.text)
                                    ? state.comagic.data.updated_at
                                    : ''}
                                </div>
                                {state.comagic.error &&
                                state.comagic.error.text ? (
                                  <div className={classes.errors}>
                                    {state.comagic.error.text}
                                    {state.comagic.error.date ? (
                                      <div>
                                        <br />
                                        Данные не выгружаются с:{' '}
                                        {state.comagic.error.date}
                                      </div>
                                    ) : (
                                      <div>
                                        <br />
                                        Нет данных
                                      </div>
                                    )}
                                  </div>
                                ) : (
                                  ''
                                )}
                                {!state.comagic.data &&
                                (!state.comagic.error ||
                                  !state.comagic.error.text) ? (
                                  <div className={classes.statisticData}>
                                    Данные пока не поступали
                                  </div>
                                ) : (
                                  ''
                                )}
                              </div>
                            </div>
                          </div>
                          {state.comagic.isAvailable ? (
                            <AccountIdentifierIcon
                              className={classes.chanelStatusIcon}
                            />
                          ) : (
                            <AccountAlertIcon
                              className={classes.chanelStatusIcon}
                            />
                          )}
                        </div>
                      </Wrapper>
                    </a>
                  ) : (
                    ''
                  )}

                  {state.calltrackingBy.settings ? (
                    <a
                      href="/calltracking/call_tracking_by/create"
                      style={{
                        color: '#000',
                      }}
                    >
                      <Wrapper
                        shadow={2}
                        style={{
                          padding: '20px 16px 20px 20px',
                          borderRadius: 8,
                          overflow: 'hidden',
                          marginTop: 32,
                          backgroundColor: 'rgba(255, 255, 255, 0.04)',
                        }}
                      >
                        <div className={classes.actions}>
                          <span className={classes.actionTitle}>
                            АВТОМАТИЧЕСКАЯ ЗАГРУЗКА ДАННЫХ ИЗ КОЛЛТРЕКИНГА
                          </span>
                          <Pencile />
                        </div>
                        <div className={classes.crmData}>
                          <div>
                            <CalltrackingByIcon height="22" />
                            {/* <div>Код активации: {state.bitrix.settings.hash}</div> */}

                            <div className={classes.crmStatisticWrapper}>
                              <div className={classes.crmStatistic}>
                                <div className={classes.statisticTitle}>
                                  Последняя отправка данных
                                </div>
                                <div className={classes.statisticData}>
                                  {state.calltrackingBy.data &&
                                  (!state.calltrackingBy.error ||
                                    !state.calltrackingBy.error.text)
                                    ? state.calltrackingBy.data.updated_at
                                    : ''}
                                </div>
                                {state.calltrackingBy.error &&
                                state.calltrackingBy.error.text ? (
                                  <div className={classes.errors}>
                                    {state.calltrackingBy.error.text}
                                    {state.calltrackingBy.error.date ? (
                                      <div>
                                        <br />
                                        Данные не выгружаются с:{' '}
                                        {state.calltrackingBy.error.date}
                                      </div>
                                    ) : (
                                      <div>
                                        <br />
                                        Нет данных
                                      </div>
                                    )}
                                  </div>
                                ) : (
                                  ''
                                )}
                                {!state.calltrackingBy.data &&
                                (!state.calltrackingBy.error ||
                                  !state.calltrackingBy.error.text) ? (
                                  <div className={classes.statisticData}>
                                    Данные пока не поступали
                                  </div>
                                ) : (
                                  ''
                                )}
                              </div>
                            </div>
                          </div>
                          {state.calltrackingBy.isAvailable ? (
                            <AccountIdentifierIcon
                              className={classes.chanelStatusIcon}
                            />
                          ) : (
                            <AccountAlertIcon
                              className={classes.chanelStatusIcon}
                            />
                          )}
                        </div>
                      </Wrapper>
                    </a>
                  ) : (
                    ''
                  )}

                  {state.uon.settings ? (
                    <a
                      href="/crm/uon"
                      style={{
                        color: '#000',
                      }}
                    >
                      <Wrapper
                        shadow={2}
                        style={{
                          padding: '20px 16px 20px 20px',
                          borderRadius: 8,
                          overflow: 'hidden',
                          marginTop: 32,
                          backgroundColor: 'rgba(255, 255, 255, 0.04)',
                        }}
                      >
                        <div className={classes.actions}>
                          <span className={classes.actionTitle}>
                            АВТОМАТИЧЕСКАЯ ЗАГРУЗКА ДАННЫХ ИЗ CRM
                          </span>
                          <Pencile />
                        </div>
                        <div className={classes.crmData}>
                          <div>
                            <UonCrmBigIcon height="22" />
                            {/* <div>Код активации: {state.bitrix.settings.hash}</div> */}

                            <div className={classes.crmStatisticWrapper}>
                              <div className={classes.crmStatistic}>
                                <div className={classes.statisticTitle}>
                                  Куда отправлять данные
                                </div>
                                <div className={classes.statisticData}>
                                  {state.uon.settings &&
                                  state.uon.settings.import_destination ==
                                    'ecom'
                                    ? 'Покупки в электронной торговле'
                                    : ''}

                                  {state.uon.settings &&
                                  state.uon.settings.import_destination ==
                                    'event'
                                    ? 'Создать цель "Успешные продажи"'
                                    : ''}
                                </div>
                              </div>
                            </div>

                            <div className={classes.crmStatisticWrapper}>
                              <div className={classes.crmStatistic}>
                                <div className={classes.statisticTitle}>
                                  Выбранные статусы сделок
                                </div>
                                <div className={classes.statisticData}>
                                  {state.uon.statuses}
                                </div>
                              </div>
                            </div>

                            {state.uon.settings.import_destination == 'ecom' ? (
                              <div className={classes.crmStatisticWrapper}>
                                <div className={classes.crmStatistic}>
                                  <div className={classes.statisticTitle}>
                                    Выбранный статус возврата
                                  </div>
                                  <div className={classes.statisticData}>
                                    {state.uon.settings.cancel_status}
                                  </div>
                                </div>
                              </div>
                            ) : (
                              ''
                            )}

                            <div className={classes.crmStatisticWrapper}>
                              <div className={classes.crmStatistic}>
                                <div className={classes.statisticTitle}>
                                  Последняя отправка данных
                                </div>
                                <div className={classes.statisticData}>
                                  {state.uon.data &&
                                  (!state.uon.error || !state.uon.error.text)
                                    ? state.uon.data.updated_at
                                    : ''}
                                </div>
                                {state.uon.error && state.uon.error.text ? (
                                  <div className={classes.errors}>
                                    {state.uon.error.text}
                                    {state.uon.error.date ? (
                                      <div>
                                        <br />
                                        Данные не выгружаются с:{' '}
                                        {state.uon.error.date}
                                      </div>
                                    ) : (
                                      <div>
                                        <br />
                                        Нет данных
                                      </div>
                                    )}
                                  </div>
                                ) : (
                                  ''
                                )}
                                {!state.uon.data &&
                                (!state.uon.error || !state.uon.error.text) ? (
                                  <div className={classes.statisticData}>
                                    Данные по продажам пока не поступали
                                  </div>
                                ) : (
                                  ''
                                )}
                              </div>
                            </div>
                          </div>
                          {state.uon.isAvailable ? (
                            <AccountIdentifierIcon
                              className={classes.chanelStatusIcon}
                            />
                          ) : (
                            <div>
                              <AccountAlertIcon
                                className={classes.chanelStatusIcon}
                              />
                            </div>
                          )}
                        </div>
                      </Wrapper>
                    </a>
                  ) : (
                    ''
                  )}

                  {state.custom.settings ? (
                    <a
                      href="/crm/custom"
                      style={{
                        color: '#000',
                      }}
                    >
                      <Wrapper
                        shadow={2}
                        style={{
                          padding: '20px 16px 20px 20px',
                          borderRadius: 8,
                          overflow: 'hidden',
                          marginTop: 32,
                          backgroundColor: 'rgba(255, 255, 255, 0.04)',
                        }}
                      >
                        <div className={classes.actions}>
                          <span className={classes.actionTitle}>
                            АВТОМАТИЧЕСКАЯ ЗАГРУЗКА ДАННЫХ ИЗ CRM
                          </span>
                          <Pencile />
                        </div>
                        <div className={classes.crmData}>
                          <div>
                            <CustomCrmBigIcon height="22" />

                            <div className={classes.crmStatisticWrapper}>
                              <div className={classes.crmStatistic}>
                                <div className={classes.statisticTitle}>
                                  Последняя отправка данных
                                </div>
                                <div className={classes.statisticData}>
                                  {state.custom.data &&
                                  (!state.custom.error ||
                                    !state.custom.error.text)
                                    ? state.custom.data.updated_at
                                    : ''}
                                </div>
                                {state.custom.error &&
                                state.custom.error.text ? (
                                  <div className={classes.errors}>
                                    {state.custom.error.text}
                                    {state.custom.error.date ? (
                                      <div>
                                        <br />
                                        Данные не выгружаются с:{' '}
                                        {state.custom.error.date}
                                      </div>
                                    ) : (
                                      <div>
                                        <br />
                                        Нет данных
                                      </div>
                                    )}
                                  </div>
                                ) : (
                                  ''
                                )}
                                {!state.custom.data &&
                                (!state.custom.error ||
                                  !state.custom.error.text) ? (
                                  <div className={classes.statisticData}>
                                    Данные по продажам пока не поступали
                                  </div>
                                ) : (
                                  ''
                                )}
                              </div>
                            </div>
                          </div>
                          {state.custom.isAvailable ? (
                            <AccountIdentifierIcon
                              className={classes.chanelStatusIcon}
                            />
                          ) : (
                            <div>
                              <AccountAlertIcon
                                className={classes.chanelStatusIcon}
                              />
                            </div>
                          )}
                        </div>
                      </Wrapper>
                    </a>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}

export default withStyles(styles)(Dashboard)
